<template>
  <div v-if="show" class="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4" style="background-color: rgba(15, 23, 42, 0.85); backdrop-filter: blur(4px);">
    <div class="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-100 text-left animate-fadeIn">
      
      <!-- Header -->
      <div style="background-color: #0f172a;" class="px-6 py-5 text-white flex items-center space-x-3">
        <div class="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center text-amber-400 text-2xl">
          <i class="fa fa-cash-register"></i>
        </div>
        <div>
          <h3 class="font-black text-lg text-white tracking-tight">Apertura de Caja Requerida</h3>
          <p class="text-xs text-amber-300 font-medium">Debe aperturar su caja para comenzar a vender</p>
        </div>
      </div>

      <!-- Contenido -->
      <div class="p-6">
        <div class="mb-5 p-3.5 rounded-xl bg-amber-50 border border-amber-200 text-xs text-amber-950">
          <p class="font-bold flex items-center mb-1 text-sm text-amber-900">
            <i class="fa fa-user-circle mr-1.5 text-amber-700"></i> Hola, {{ userName }}
          </p>
          <p class="text-gray-700">
            Cada cajero responde por su propia caja. Por favor, declara el dinero físico con el que inicias en la gaveta.
          </p>
        </div>

        <form @submit.prevent="submitOpen">
          <!-- Saldo inicial USD -->
          <div class="mb-3.5">
            <label class="block text-xs font-bold uppercase text-gray-700 mb-1">
              <i class="fa fa-dollar-sign text-emerald-600 mr-1"></i> Saldo Inicial Dólares ($ USD)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model.number="form.opening_balance_usd"
              required
              class="w-full px-3.5 py-2.5 rounded-xl font-bold text-gray-900 bg-white border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              placeholder="0.00"
            />
          </div>

          <!-- Saldo inicial COP -->
          <div class="mb-3.5">
            <label class="block text-xs font-bold uppercase text-gray-700 mb-1">
              <i class="fa fa-coins text-emerald-600 mr-1"></i> Saldo Inicial Pesos (COP)
            </label>
            <input
              type="number"
              step="any"
              min="0"
              v-model.number="form.opening_balance_cop"
              required
              class="w-full px-3.5 py-2.5 rounded-xl font-bold text-gray-900 bg-white border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              placeholder="0"
            />
          </div>

          <!-- Saldo inicial BS -->
          <div class="mb-5">
            <label class="block text-xs font-bold uppercase text-gray-700 mb-1">
              <i class="fa fa-money-bill-wave text-emerald-600 mr-1"></i> Saldo Inicial Bolívares (Bs)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              v-model.number="form.opening_balance_bs"
              required
              class="w-full px-3.5 py-2.5 rounded-xl font-bold text-gray-900 bg-white border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
              placeholder="0.00"
            />
          </div>

          <!-- Botón de apertura -->
          <button
            type="submit"
            :disabled="loading"
            class="w-full py-3.5 px-4 bg-emerald-600 hover:bg-emerald-700 text-white font-extrabold text-sm rounded-xl shadow-lg shadow-emerald-200 transition-all flex items-center justify-center space-x-2 cursor-pointer"
            :class="loading ? 'opacity-60 cursor-not-allowed' : ''"
          >
            <i v-if="loading" class="fa fa-spinner fa-spin text-lg"></i>
            <i v-else class="fa fa-lock-open text-lg"></i>
            <span>Aperturar Mi Caja y Comenzar</span>
          </button>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenCashRegisterModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    userName: {
      type: String,
      default: 'Usuario'
    }
  },

  data() {
    return {
      loading: false,
      form: this.$inertia.form({
        opening_balance_usd: 0,
        opening_balance_cop: 0,
        opening_balance_bs: 0,
      })
    }
  },

  methods: {
    submitOpen() {
      if (this.loading) return
      this.loading = true

      this.form.post('/cash-registers/open-for-user', {
        preserveScroll: true,
        onSuccess: () => {
          this.loading = false
          this.$emit('opened')
        },
        onError: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-fadeIn {
  animation: fadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
</style>
